import React from "react";
import PropTypes from "prop-types";

const KeyNumbersGraphic = ({ data, icons }) => {
  const {
      urban_population, total_population, gdp, average_tariff, people_connected_to_water, people_connected_to_wastewater, percentage_connected_to_water, percentage_connected_to_wastewater, number_of_water_connections, number_of_wastewater_connections, utility_water_capacity, percentage_wastewater_collected, volume_wastewater
    } = data;

  const {
    gdpIcon,
    percentConnectedIcon,
    percentWastewaterCollectedIcon,
    populationIcon,
    tariffIcon,
    urbanIcon,
    volumeWastewaterProducedIcon,
    wastewaterConnectionsIcon,
    waterCapacityIcon,
    waterConnectionsIcon,
  } = icons;

  return (
      <div>
        <div className="red">
          <ul className="keyNumbers-list">
            <li className="population">
              <img src={populationIcon} />
              <div className="label">Total population</div>
              <div className="value">
                {total_population[0] ? total_population[0] : "-"}
                <span className="date">{total_population[1] ? `${total_population[1]}` : ""}</span>
              </div>
            </li>
            <li className="urban">
              <img src={urbanIcon} />
              <div className="label">% population in urban areas</div>
              <div className="value">
                {urban_population[0] ? `${urban_population[0]}%` : "-"}
                <span className="date">{urban_population[1] ? `${urban_population[1]}` : ""}</span>
              </div>
            </li>
            <li>
              <img src={gdpIcon} />
              <div className="label">GDP</div>
              <div className="value">
                {gdp[0] ? `$US ${gdp[0]}` : "-"}
                <span className="date">{gdp[1] ? `${gdp[1]}` : ""}</span>
              </div>
            </li>
            <li className="tariff">
              <img src={tariffIcon} />
              <div className="label">Average tariff</div>
              <div className="value">
                {average_tariff[0] && average_tariff[0] != "&ndash;"
                ? <span dangerouslySetInnerHTML={{ __html: `$US ${average_tariff[0]} / m<sup>3</sup>` }} />
                : "-"}
                <span className="date">{average_tariff[1] ? `${average_tariff[1]}` : ""}</span>
              </div>
            </li>
          </ul>
        </div>
        <div className="green">
          <ul className="keyNumbers-list">
            <li className="population">
              <img src={populationIcon} />
              <div className="label">People connected to water network</div>
              <div className="value">
                {people_connected_to_water[0] ? people_connected_to_water[0]: "-"}
                <span className="date">{people_connected_to_water[1] ? `${people_connected_to_water[1]}` : ""}</span>
              </div>
            </li>
            <li className="pie-chart">
              <img src={percentConnectedIcon} />
              <div className="label">% people connected to water network</div>
              <div className="value">
                {percentage_connected_to_water[0] ? `${percentage_connected_to_water[0]}%` : "-"}
                <span className="date">{percentage_connected_to_water[1] ? `${percentage_connected_to_water[1]}` : ""}</span>
              </div>
            </li>
            <li className="water-connections">
              <img src={waterConnectionsIcon} />
              <div className="label">No. of water connections</div>
              <div className="value">
                {number_of_water_connections[0] ? number_of_water_connections[0] : "-"}
                <span className="date">{number_of_water_connections[1] ? `${number_of_water_connections[1]}` : ""}</span>
              </div>
            </li>
            <li className="utility">
              <img src={waterCapacityIcon} />
              <div className="label">Utility water supply capacity</div>
              <div className="value">
                {utility_water_capacity[0]
                ? <span dangerouslySetInnerHTML={{ __html: `${utility_water_capacity[0]} km<sup>3</sup> / year` }} />
                : "-"}
                <span className="date">{utility_water_capacity[1] ? `${utility_water_capacity[1]}` : ""}</span>
              </div>
            </li>
          </ul>
        </div>
        <div className="purple">
          <ul className="keyNumbers-list">
            <li className="population">
              <img src={populationIcon} />
              <div className="label">People connected to wastewater network</div>
              <div className="value">
                {people_connected_to_wastewater[0] ? people_connected_to_wastewater[0] : "-"}
                <span className="date">{people_connected_to_wastewater[1] ? `${people_connected_to_wastewater[1]}` : ""}</span>
              </div>
            </li>
            <li className="urban">
              <img src={percentConnectedIcon} />
              <div className="label">% of people connected to wastewater network</div>
              <div className="value">
                {percentage_connected_to_wastewater[0] ? `${percentage_connected_to_wastewater[0]}%` : "-"}
                <span className="date">{percentage_connected_to_wastewater[1] ? `${percentage_connected_to_wastewater[1]}` : ""}</span>
              </div>
            </li>
            <li>
              <img src={wastewaterConnectionsIcon} />
              <div className="label">No. of wastewater connections</div>
              <div className="value">
                {number_of_wastewater_connections[0] ? number_of_wastewater_connections[0] : "-"}
                <span className="date">{number_of_wastewater_connections[1] ? `${number_of_wastewater_connections[1]}` : ""}</span>
              </div>
            </li>
            <li>
              <img src={volumeWastewaterProducedIcon} />
              <div className="label">Volume of wastewater produced</div>
              <div className="value">
                {volume_wastewater[0]
                ? <span dangerouslySetInnerHTML={{ __html: `${volume_wastewater[0]} km<sup>3</sup> / year` }} />
                : "-"}
                <span className="date">{volume_wastewater[1] ? `${volume_wastewater[1]}` : ""}</span>
              </div>
            </li>
            <li>
              <img src={percentWastewaterCollectedIcon} />
              <div className="label">% of wastewater collected</div>
              <div className="value">
                {percentage_wastewater_collected[0] ? `${percentage_wastewater_collected[0]}%` : "-"}
                <span className="date">{percentage_wastewater_collected[1] ? `${percentage_wastewater_collected[1]}` : ""}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
  );
};

export default KeyNumbersGraphic;

KeyNumbersGraphic.propTypes = {
  data: PropTypes.shape({}).isRequired,
  icons: PropTypes.shape({}).isRequired
};
